import React, { useEffect, useState } from "react";
import { Modal, Button, Row, Col, Form, Card } from "react-bootstrap";
import SuperCorrectiveActionReportView from "./SuperCorrectiveActionReportView";
import axios from "axios";
import { toast } from "react-toastify";
import config from "../../config/config";
import { getAuthToken } from "../../utils/token";
import { formatDate } from "../../utils/formatDate";
import Loader from "../loader/Loader";

function NcReportView({ show, handleClose, ncReportId,refreshParent }) {
  const [superCorrectiveActionReport, setSuperCorrectiveActionReport] =
    useState(false);
  const [productList, setProductList] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchShowncreportList = async () => {
    const token = getAuthToken();
    if (!token || !ncReportId) return;

    setLoading(true);
    try {
      const res = await axios.get(
        `${config.API}/supervisor/ncreportshistoryview/${ncReportId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res?.data?.success) {
        setProductList(res.data.nc_report);
        console.log(res?.data)
      }
    } catch (err) {
      toast.error("Failed to load NC report");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show && ncReportId) {
      fetchShowncreportList();
    }
  }, [show, ncReportId]);


  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="lg"
        className="font_family"
      >
        {
          loading ? (
            <Loader/>
          ):(
            <Modal.Body className="p-5">
          <strong className="fs-4">NC Report</strong>
                <Card className="mb-4 bg-light mt-4">
                  <Card.Body>
                    <Row>
                      <Col md={6}>
                        <strong>Product Name:</strong>{" "}
                        {productList?.product?.name}
                      </Col>
                      <Col md={6}>
                        <strong>Product ID:</strong>{" "}
                        {productList?.product?.product_code}
                      </Col>
                    </Row>

                    <Row className="mt-2">
                      <Col md={6}>
                        <strong>Qty NC:</strong>{" "}
                        {productList?.nc_count || 0}
                      </Col>
                      <Col md={6}>
                        <strong>Report Date:</strong>{" "}
                        {productList?.created_at
                          ? formatDate(productList?.created_at)
                          : "-"}
                      </Col>
                    </Row>

                    <Row className="mt-2">
                      <Col md={6}>
                        <strong>Reported by:</strong>{" "}
                        {productList?.user?.name}
                      </Col>
                      <Col md={6}>
                        <strong>NC Type:</strong>{" "}
                        {productList?.reason}
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>

                <Row className="mb-3">
                  <Col md={3}>
                    <Form.Label>Quantity Inspected</Form.Label>
                  </Col>
                  <Col md={3}>
                    <Form.Control
                      type="number"
                      value={productList?.nc_inspected ?? 0}
                      readOnly
                    />
                  </Col>

                  <Col md={2}>
                    <Form.Label>Unit</Form.Label>
                  </Col>
                  <Col md={4}>
                    <Form.Control
                      value={productList?.unit || "pcs"}
                      readOnly
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={3}>
                    <Form.Label>Quantity on Hold</Form.Label>
                  </Col>
                  <Col md={3}>
                    <Form.Control
                      type="number"
                      value={productList?.nc_hold ?? 0}
                      readOnly
                    />
                  </Col>

                  <Col md={3}>
                    <Form.Label>Quantity Passed</Form.Label>
                  </Col>
                  <Col md={3}>
                    <Form.Control
                      type="number"
                      value={productList?.nc_passed ?? 0}
                      readOnly
                    />
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Col md={2}>
                    <strong>NC Reason</strong>
                  </Col>
                  <Col md={10}>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      value={productList?.description || ""}
                      readOnly
                    />
                  </Col>
                </Row>
            
        </Modal.Body>
          )
        }

        <Modal.Footer className="border-0 mb-4">
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="outline-dark"
            onClick={() => setSuperCorrectiveActionReport(true)}
            disabled={!productList}
          >
            View Corrective Measure
          </Button>
        </Modal.Footer>
      </Modal>

      <SuperCorrectiveActionReportView
      ncReportId={ncReportId}
        show={superCorrectiveActionReport}
        handleClose={() => setSuperCorrectiveActionReport(false)}
      />
    </>
  );
}

export default NcReportView;